<div class="d-flex flex-column align-items-center px-3">

</div>
<div class="scrollable-container" ref="scrollContainer" @scroll="handleScroll">
  <div class="masonry-grid" ref="masonryGrid">
    <div
    v-for="(report, index) in filtered_reports"
    :key="report.id"
    class="masonry-item"
    >
    <router-link
    :to="`/view_full_report/${report.id}/${$route.params.portal_id}/${$route.params.portal_name}`"
    class="text-decoration-none text-dark"
    >
    <div class="card mb-4 shadow-sm border-0 rounded-5 h-100">

    <!-- 🔹 Created by section with dropdown -->
    <div class="d-flex align-items-center justify-content-between p-3">
      <!-- Profile + Name + Date -->
      <div class="d-flex align-items-center">
        <img
          :src="report.base_profile?.profile_pic || 'https://cdn-icons-png.flaticon.com/512/149/149071.png'"
          alt="Profile"
          class="rounded-circle me-2"
          width="40" height="40"
        />
        <div>
          <p class="m-0 fw-bold">
            {{ report.base_profile?.user?.first_name }} {{ report.base_profile?.user?.last_name }}
          </p>
          <small class="text-muted">
            <i class="bi bi-clock me-1"></i> {{ report.publication_date }}
          </small>
        </div>
      </div>
    </div>

    <!-- 🔹 Media Section -->
    <div class="d-flex flex-column">
      <!-- Uploaded Files -->
      <div v-for="(fileObj, index) in report.report_files" :key="index" class="mb-3">
        <!-- IMAGE FILES including base64 -->
        <div
          class="media-container image-only mb-3"
          v-if="fileObj?.file?.url &&
                (
                  fileObj.file.url.includes('.jpg') ||
                  fileObj.file.url.includes('.JPG') ||
                  fileObj.file.url.includes('.png') ||
                  fileObj.file.url.includes('.PNG') ||
                  fileObj.file.url.includes('.avif') ||
                  fileObj.file.url.includes('.AVIF') ||
                  fileObj.file.url.includes('.jpeg') ||
                  fileObj.file.url.includes('.JPEG') ||
                  fileObj.file.url.includes('.webp') ||
                  fileObj.file.url.includes('.WEBP') ||
                  fileObj.file.url.startsWith('data:image')
                )"
        >
          <img
            :src="fileObj.file.url"
            alt="Feed Image"
            class="media-item rounded-5"
            @click="display_comment_modal(report)"
          />
        </div>

        <!-- AUDIO FILES -->
        <div
          class="media-container video-audio mb-3"
          v-else-if="fileObj?.file?.url &&
                    (fileObj.file.url.includes('.mp3') ||
                    fileObj.file.url.includes('.wav'))"
        >
          <audio controls class="rounded-3 p-1">
            <source
              :src="fileObj.file.url"
              :type="fileObj.file.url.includes('.mp3') ? 'audio/mpeg' : 'audio/wav'"
            />
          </audio>
        </div>

        <!-- VIDEO FILES -->
        <div
          class="media-container video-audio mb-3"
          v-else-if="fileObj?.file?.url && /\.(mp4|webm|ogg|ogv|mov|m4v|avi|mkv|wmv|flv|3gp|3g2)(?:$|[?#])/i.test(fileObj.file.url)"
        >
          <video controls class="media-item rounded-5" @click="display_comment_modal(report)">
            <source :src="fileObj.file.url" />
          </video>
        </div>

        <!-- OTHER FILES -->
        <div v-else class="uploaded-file" @click="display_comment_modal(report)">
          <img
            v-if="fileObj?.file?.url"
            :src="getFileIcon(fileObj.file.url)"
            class="file-icon small-icon"
          />
          <span class="file-name text-break">{{ getFileName(fileObj?.file?.url) }}</span>
          <a
            :href="fileObj?.file.url"
            download
            :title="getFileName(fileObj?.file?.url)"
            class="download-btn"
            @click.stop
          >
            <img src="https://cdn-icons-png.flaticon.com/128/724/724933.png" class="download-icon" />
          </a>
        </div>
      </div>

      <!-- Quill Images -->
      <div v-if="getQuillImages(report).length">
        <div :id="'carousel-' + report.id" class="carousel slide">
          <!-- Indicators -->
          <div class="carousel-indicators">
            <button
              v-for="(src, i) in getQuillImages(report)"
              :key="'indicator-' + i"
              type="button"
              :data-bs-target="'#carousel-' + report.id"
              :data-bs-slide-to="i"
              :class="{ active: i === 0 }"
              aria-current="i === 0 ? 'true' : undefined"
              :aria-label="'Slide ' + (i + 1)"
            ></button>
          </div>

          <!-- Carousel Inner -->
          <div class="carousel-inner">
            <div
              v-for="(src, i) in getQuillImages(report)"
              :key="'carousel-img-' + i"
              :class="['carousel-item', { active: i === 0 }]"
            >
              <img
                :src="src"
                class="d-block  rounded-5 publish-image"
                alt="Quill Image"
                @click="display_comment_modal(report)"
              />
            </div>
          </div>

          <!-- Controls -->
          <button
            class="carousel-control-prev"
            type="button"
            :data-bs-target="'#carousel-' + report.id"
            data-bs-slide="prev"
          >
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </button>
          <button
            class="carousel-control-next"
            type="button"
            :data-bs-target="'#carousel-' + report.id"
            data-bs-slide="next"
          >
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </button>

        </div>
      </div>
    </div>

    <!-- 🔹 Card Body -->
    <div class="card-body">

      <!-- Description -->
      <p class="card-text text-muted text-xs" v-html="get_description(report)"></p>
      <a v-if="report.description && report.description.length > 250"
          href="#"
          @click.prevent="toggle_description(report.id)"
          class="text-secondary text-decoration-none fw-bold text-xs">
        {{ expandedReports.includes(report.id) ? 'Read less' : 'Read more' }}
      </a>

      <!-- Admin Buttons -->
      <div v-if="user_details.user_role === 'admin' && report.status?.name === 'pending'"
            class="mt-3 d-flex gap-2">
        <button class="btn btn-sm btn-success rounded-pill px-3"
                @click.stop.prevent="approve_report(report.id)">
          <i class="bi bi-check-circle me-1"></i> Approve
        </button>
        <button class="btn btn-sm btn-danger rounded-pill px-3"
                @click.stop.prevent="reject_report(report.id)">
          <i class="bi bi-x-circle me-1"></i> Reject
        </button>
      </div>
    </div>
    </div>
    </router-link>
    </div>
  </div>
</div>
